// googleBotRegex.js
'use strict';

/**
 * Unified Google bot regex that covers all Google crawlers and bots
 * This regex is used by both server-side (middleware) and client-side (getUserAgent) code
 *
 * Includes:
 * - googlebot: Main Google search crawler
 * - google-structured-data-testing-tool: Structured data testing tool
 * - google-read-aloud: Google Read Aloud service
 * - google-adwords-instant: Google Ads instant crawler
 * - google-ads-creatives-assistant: Google Ads creatives assistant
 * - adsbot-google: Google Ads crawler
 * - feedfetcher-google: Google RSS feed fetcher
 * - google-cloudvertexbot: Google Cloud Vertex AI bot
 * - google-inspectiontool: Google Search Console inspection tool
 * - google-site-verification: Google site verification service
 */
export const GOOGLE_BOT_REGEX =
  /googlebot|google-structured-data-testing-tool|google-read-aloud|google-adwords-instant|google-ads-creatives-assistant|adsbot-google|feedfetcher-google|google-cloudvertexbot|google-inspectiontool|google-site-verification/i;
